import { render, staticRenderFns } from "./TicketMonthTrend.vue?vue&type=template&id=06d109b8&scoped=true&"
import script from "./TicketMonthTrend.vue?vue&type=script&lang=js&"
export * from "./TicketMonthTrend.vue?vue&type=script&lang=js&"
import style0 from "./TicketMonthTrend.vue?vue&type=style&index=0&id=06d109b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d109b8",
  null
  
)

export default component.exports